import settings from '@/settings'
document.title = settings.title